import { Component, OnInit, ViewChild } from '@angular/core';
import { ForecastService } from '../forecast.service';
import { AppDevNotifyComponent } from './../../../widgets/dev-notify-bar/dev-notify-bar.component';
import { ForecastAjstGroupsData, ForecastAjstSplitBaseData, ForecastAjstElementData, TopdownAdjustmentParam, TopdownAdjustmentListItem, TopdownAddAdjustmentParam, ForecastElementCaptionData } from 'src/app/models/forecast/topdown-adjustment.model';
import { DxSelectBoxComponent } from 'devextreme-angular';



@Component({
    selector: 'app-topdown-adjustment',
    templateUrl: './topdown-adjustment.component.html',
    styleUrls: ['./topdown-adjustment.component.scss'],
    standalone: false
})
export class TopdownAdjustmentComponent implements OnInit {

  constructor(private forecastService: ForecastService) { }

  elementName = "elementName";
  forecastGroup = "forecastGroup";
  elementCaption="";
  forecastGroupsDdlData: ForecastElementCaptionData[];
  forecastGroupValuesDdlData: ForecastAjstGroupsData[];

  splitBasesDdlData: ForecastAjstSplitBaseData[];
  forecastElementsDdlData: ForecastAjstElementData[];
  unitElementsDdlData: ForecastAjstElementData[];
  topDownData: TopdownAdjustmentParam = new TopdownAdjustmentParam();

  defaultElement: string = null;

  //dev express setting changes function for chart need on resize after windows size changes
  @ViewChild("dxForecastElemntName", { static: false }) dxForecastElemntName: DxSelectBoxComponent;
  @ViewChild("dxForecastValuesGroupName", { static: false }) dxForecastValuesGroupName: DxSelectBoxComponent;
  @ViewChild("dxForecastGroupName", { static: false }) dxForecastGroupName: DxSelectBoxComponent;
  @ViewChild("dxSplitbase", { static: false }) dxSplitbase: DxSelectBoxComponent;
  @ViewChild("dxForecastUnitMeasure", { static: false }) dxForecastUnitMeasure: DxSelectBoxComponent;

  ngOnInit() {

    this.forecastService.GetTopdownAdjustmentLoadData().subscribe(result => {

      this.forecastGroupsDdlData = result.forecastGroups;
      this.forecastElementsDdlData = result.forecastElements;

      this.splitBasesDdlData = result.splitBases;
      if (result.splitBases != null && result.splitBases.length > 0) {
        if (this.dxSplitbase != null) {
          this.defaultElement = result.splitBases[0].defaultElement.toString();
          this.dxSplitbase.value = this.defaultElement;

        }
      }

      this.unitElementsDdlData = result.unitElements;



    }, (err) => {
      AppDevNotifyComponent.ErrorMessage("Sorry, something went wrong. Please try after some time again.");

    });
  }

  showGroupValues(event) {

    this.forecastService.GetTopdownAdjustmentLoadGroupData(this.dxForecastGroupName.value).subscribe(result => {

      this.forecastGroupValuesDdlData = result;
    }, (err) => {
      AppDevNotifyComponent.ErrorMessage("Sorry, something went wrong. Please try after some time again.");

    });
  }

  forecastAjstListData: TopdownAdjustmentListItem[] = [];

  searchData(event) {


    if (this.dxForecastValuesGroupName != null) {
      this.topDownData.forecastGroupValue = this.dxForecastValuesGroupName.value;
    }

    if (this.dxForecastGroupName != null) {
      this.topDownData.forecastGroupName = this.dxForecastGroupName.value;
    }

    if (this.dxForecastElemntName != null) {
      this.topDownData.forecastElemntName = this.dxForecastElemntName.value;
    }

    if (this.dxSplitbase != null) {
      this.topDownData.splitbase = this.dxSplitbase.value;
    }

    if (this.dxForecastUnitMeasure != null) {
      this.topDownData.forecastUnitMeasure = this.dxForecastUnitMeasure.value;
    }


    this.forecastService.GetTopdownAdjustmentListData(this.topDownData).subscribe(result => {

      result.forecastAdjustmentItem.forEach(element => {
        if(element.removeAjestValue==null || element.removeAjestValue== undefined)
        {
          element.removeAjestValue = false;
        }

      });

      this.forecastAjstListData = result.forecastAdjustmentItem;


    }, (err) => {
      AppDevNotifyComponent.ErrorMessage("Sorry, something went wrong. Please try after some time again.");

    });
  }

  updateDataValueChange(data, action) {
    if (data != null && action != null) {

      /* getting index for both for update */
      let updateforecastAjstListData = this.forecastAjstListData.find(x => x.period == data.period);
      let indexUpdate = this.forecastAjstListData.indexOf(updateforecastAjstListData);
      if (this.forecastAjstListData != null && this.forecastAjstListData[indexUpdate] != null) {

        if (action == 'EditAjtTemplate') {
          if (data != null && data.ajestValue != null) {
            this.forecastAjstListData[indexUpdate].removeAjestValue = false;
          }
        }

        else if (action == 'EditRevAjtTemplate') {

          if (data != null && data.removeAjestValue != null && data.removeAjestValue == true) {
            this.forecastAjstListData[indexUpdate].ajestValue = null;
          }

        }
      }
    }

  }

  resetFilters() {
    this.dxForecastElemntName.value = null;
    this.dxForecastGroupName.value = null;
    this.dxSplitbase.value = this.defaultElement;;
    this.dxForecastUnitMeasure.value = null;
    this.forecastAjstListData = [];
  }


  saveAllChanges() {

    if (this.forecastAjstListData != null && this.forecastAjstListData.length > 0) {

      let data: TopdownAddAdjustmentParam = new TopdownAddAdjustmentParam();
      data.forecastElementId = this.topDownData.forecastElemntName;

      data.forecastGroupValue = this.topDownData.forecastGroupValue;


      data.forecastGroupName = this.topDownData.forecastGroupName;


      data.forecastSplit = this.topDownData.splitbase;
      data.unitOfMeasure = this.topDownData.forecastUnitMeasure;
      data.topdownAjst = [];

      for (let i = 0; i < this.forecastAjstListData.length; i++) {
        if (this.forecastAjstListData != null) {
          data.topdownAjst.push({
            period: this.forecastAjstListData[i].period,
            ajestValue: this.forecastAjstListData[i].ajestValue,
            removeAjestValue: this.forecastAjstListData[i].removeAjestValue
          });
        }
      }
      this.forecastService.AddUpdateAdjustmentData(data).subscribe(result => {
        if (result != null) {
          if (result.flag > 0) {
            AppDevNotifyComponent.SuccesMessage(result.msg);
          } else {
            AppDevNotifyComponent.ErrorMessage(result.msg);
          }
        } else {
          AppDevNotifyComponent.ErrorMessage("Sorry, Something went wrong. Please try after some time again.");
        }


      }, (err) => {
        AppDevNotifyComponent.ErrorMessage("Sorry, something went wrong. Please try after some time again.");

      });

    }
    else {
      AppDevNotifyComponent.ErrorMessage("Sorry, There is no data to be updated. Please try after some time again.");
    }
  }

}
